#
# VARIABLES
#

# MONTH MAP
window.MonthNames = {
    de: [ "Januar", "Feburar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember" ]
    en: [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ]
}

#
# (EXTERNAL) LINK CHECKER
#
CheckForExternalLinks = ->
    document.querySelectorAll 'a:not([data-el-checked])'
        .forEach (linkElem) ->
            if linkElem.href
                if new URL(linkElem.href).origin != location.origin
                    linkElem.target = '_blank'
                    linkElem.dataset.elChecked = "true"
                    linkElem.rel = "noreferrer"
            return
    return

#CheckForExternalLinks()
window.addEventListener 'bind-components', CheckForExternalLinks

#
# LINKABLE ELEMENTS
#
class LinkableElement
    constructor: (el) ->
        @.$el = el
        @.$buttonEl = @.$el.querySelector '.button'
        @.$linkButtonEl = @.$el.querySelector '.link-button'

        @.$el.classList.add 'linkable-element--bound'
        @.InitEvents()
        return
    
    InitEvents: ->
        self = @
        @.$el.addEventListener 'click', (e) ->
            if self.$linkButtonEl
                self.$linkButtonEl.click()
            else
                if self.$buttonEl
                    self.$buttonEl.click()
            return
        return

BindLinkableElements = ->
    document.querySelectorAll '.linkable-element:not(.linkable-element--bound)'
        .forEach (el) ->
            new LinkableElement el
            return
    return

window.addEventListener 'bind-components', BindLinkableElements

#
# TYPO3 FORM FILE UPLOADS
#
class Typo3FormFileUpload
    constructor: (el) ->
        @.$el = el
        @.$buttonEl = @.$el.querySelector '.typo3-form-file-upload__button'
        @.$fileHintEl = @.$el.querySelector '.typo3-form-file-upload__text'
        @.$fileInputEl = @.$el.querySelector 'input[type="file"]'

        @.$el.classList.add 'typo3-form-file-upload--bound'
        @.InitEvents()
        return
    
    InitEvents: ->
        self = @
        if @.$buttonEl
            @.$buttonEl.addEventListener 'click', (e) ->
                e.preventDefault()
                e.stopPropagation()
                console.log "CLICK"
                if self.$fileInputEl
                    self.$fileInputEl.click()
                return
        if @.$fileInputEl
            @.$fileInputEl.addEventListener 'change', (e) ->
                fileName = ""
                if @.files && @.files.length > 1
                    fileName = ( @.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', @.files.length )
                else
                    fileName = e.target.value.split('\\').pop()
                if fileName && fileName != ""
                    self.$fileHintEl.textContent = fileName
                    self.$el.classList.add 'typo3-form-file-upload--file'
                else
                    self.$fileHintEl.textConent = "Keine Datei ausgewählt"
                    self.$el.classList.remove 'typo3-form-file-upload--file'
                return
        return
    
BindSFRegisterCustomFileUploads = ->
    document.querySelectorAll '.typo3-form-file-upload:not(.typo3-form-file-upload--bound)'
        .forEach (el) ->
            new Typo3FormFileUpload el
            return
    return

window.addEventListener 'bind-components', BindSFRegisterCustomFileUploads

#
# SITE CONTROL
#

class SiteControl
    constructor: (el) ->
        @.$el = el
        @.$contentEl = @.$el.querySelector '#content'
        @.$headerEl = @.$el.querySelector '.header'

        @.pageLastScroll = 0

        @.$el.classList.add 'site--bound'
        @.InitEvents()
        return
    
    InitEvents: ->
        self = @
        @.$el.addEventListener 'site-set-scroll-state', (e) ->
            deprive = e.detail?.deprive ? false
            self.SetScrollState deprive
            return
        return
    
    SetScrollState: (deprive) ->
        if @.$contentEl && @.$headerEl 
            if deprive
                @.pageLastScroll = window.scrollY
                @.$el.classList.add 'site--no-scroll'
                @.$contentEl.style.transform = "translateY(-#{ @.pageLastScroll }px)"
                @.$headerEl.style.transform = "translateY(-#{ @.pageLastScroll }px)"
            else
                @$el.classList.remove 'site--no-scroll'
                @.$contentEl.style.removeProperty "transform"
                @.$headerEl.style.removeProperty "transform"
                window.scrollTo 0, @.pageLastScroll
        return

BindSiteControl = ->
    siteEl = document.querySelector '#site'
    if siteEl
        new SiteControl siteEl
    return

BindSiteControl()
        

#
# SLIDER
#
class Slider
    constructor: (el) ->
        @.$el = el
        @.$slides = @.$el.querySelectorAll '.slider__slide'
        @.$track = @.$el.querySelector '.slider__track'

        @.activeSlide = 0
        @.cursorX = 0
        @.resizeDelay = 300
        @.resizeInterval = undefined
        @.slidesGap = (parseInt(window.getComputedStyle(@.$track,null).getPropertyValue("gap"), 10) / 10)
        @.slidesMoved = 0
        @.slideWidth = 0
        @.trackMovement = 0
        @.trackMovementScrollThreshold = 20

        if @.$slides.length > 0
            @.slideWidth = @.$slides[0].getBoundingClientRect().width
            @.InitEvents()
            @.$el.classList.add 'slider--bound'
        return
    
    CalculateTrackMovement: (clientX) ->
        @.trackMovement = clientX - @.cursorX
        @.$track.style.left = "#{ @.trackMovement }px"
        @.slidesMoved = (-1)*(@.trackMovement / @.slideWidth)
        return
    
    InitEvents: ->
        self = @
        @.$el.addEventListener 'slider-slide-to', (e) ->
            slide = e.detail?.slide ? 0
            dontDispatch = e.detail?.dontDispatch ? false
            self.SlideTo slide, dontDispatch
            return
        @.$el.addEventListener 'keyup', (e) ->
            if e.key == 'ArrowLeft'
                self.SlideTo self.activeSlide - 1
            if e.key == 'ArrowRight'
                self.SlideTo self.activeSlide + 1
            return
        @.$track.addEventListener 'mousedown', (e) ->
            self.StartTrackMovement e.clientX
            return
        @.$track.addEventListener 'touchstart', (e) ->
            self.StartTrackMovement e.touches[0].clientX
            return
        @.$track.addEventListener 'mouseup', (e) ->
            self.ResetTrackDownState()
            return
        @.$track.addEventListener 'touchend', (e) ->
            self.ResetTrackDownState()
            return
        @.$track.addEventListener 'mouseleave', (e) ->
            self.ResetTrackDownState()
            return
        @.$track.addEventListener 'touchleave', (e) ->
            self.ResetTrackDownState()
            return
        @.$track.addEventListener 'mousemove', (e) ->
            if self.$el.classList.contains 'slider--track-down'
                self.CalculateTrackMovement e.clientX
            return
        @.$track.addEventListener 'touchmove', (e) ->
            if self.$el.classList.contains 'slider--track-down'
                if self.trackMovement > self.trackMovementScrollThreshold || self.trackMovement < ((-1) * self.trackMovementScrollThreshold)
                    if e.cancelable
                        e.preventDefault()
                        e.stopPropagation()
                self.CalculateTrackMovement e.touches[0].clientX
            return
        @.$el.addEventListener 'slider-update', (e) ->
            self.$slides = self.$el.querySelectorAll '.slider__slide'
            return
        window.addEventListener 'resize', (e) ->
            window.clearInterval self.resizeInterval
            self.resizeInterval = window.setInterval ->
                window.clearInterval self.resizeInterval
                self.ResizeCalculation()
                return
            , self.resizeDelay
            return
        return
    
    ResetTrackDownState: ->
        @.$track.style.left = 0
        @.$el.classList.remove 'slider--track-down'
        @.cursorX = 0
        @.trackMovement = 0
        moveSlides = (if @.slidesMoved < 0 then Math.floor(@.slidesMoved) + @.activeSlide else Math.ceil(@.slidesMoved) + @.activeSlide)
        @.slidesMoved = 0
        if moveSlides < 0
            moveSlides = 0
        if moveSlides > @.$slides.length - 1
            moveSlides = @.$slides.length - 1
        @.SlideTo moveSlides
        return
    
    ResizeCalculation: ->
        @.slidesGap = (parseInt(window.getComputedStyle(@.$track,null).getPropertyValue("gap"), 10) / 10)
        @.SlideTo @.activeSlide, true
        return

    SlideTo: (slide, dontDispatch) ->
        if slide > @.$slides.length - 1
            slide = 0
        if slide < 0
            slide = @.$slides.length - 1
        self = @
        @.$slides.forEach (slideEl) ->
            slideEl.style.transform = "translateX(calc(-#{ slide * 100 }% - #{ slide * self.slidesGap }rem))"
            return
        @.activeSlide = slide
        if !dontDispatch
            @.$el.dispatchEvent new CustomEvent 'slider-slid', {
                bubbles: false,
                detail: {
                    activeSlide: self.activeSlide
                }
            }
        return
    
    StartTrackMovement: (clientX) ->
        if @.$slides.length > 1
            @.cursorX = clientX
            @.slideWidth = @.$slides[0].getBoundingClientRect().width
            @.$el.classList.add 'slider--track-down'
        return
    
BindSliders = ->
    document.querySelectorAll '.slider:not(.slider--bound)'
        .forEach (el) ->
            new Slider el
            return
    return

window.addEventListener 'bind-components', BindSliders